var storeUrl = 'smart-liner-usa.myshopify.com';
var appUrl = 'https://smart-max-liner.thegenielab.com';
var appUrlTwo = 'https://smart-max-liner-2.thegenielab.com';

(function($) {
$(function () {
  TabView("tab", "tabview");
  resetUserSelection();
  // Getting makes list
  var checkMakeLength = $(".select_car_make option").length;
  if(checkMakeLength == 1 || checkMakeLength == 2){

    loadMakeDropdown();
    
  }
  
  function generateVehicleSelectorWarning() {
    return `
        <div style="background: #24272acc; display: flex; flex-direction: row; justify-content: center;">
            <h2 style=" font-size: 18px; color: #ffffff; font-weight: bold; margin: 20px; text-transform: uppercase;" > Select Your Vehicle <h2>
        </div>
    `;
}
  
  
  
  // Getting model list
  
  $(".select_car_make").change(function() {
    
      var $dropdown = $(this);
    
      var makeVal = $dropdown.val();
    if(makeVal != '0'){

       var vehicle_type = $('.tab-buttons .on').data('val');
        if(vehicle_type == 'UTV'){
          var modelListUrl = appUrlTwo+'/json/models/list';
        }else{
          var modelListUrl = appUrl+'/json/models/list';
        }
        
       modelListUrl = modelListUrl+'/'+makeVal+'?shop='+storeUrl;
      
       
      $.getJSON(modelListUrl, function(data) {

          
        var vals = data.results;
    var $modelsDropdown = $(".select_car_model");
        $modelsDropdown.empty();
        $modelsDropdown.append("<option value="+0+">" + 'SELECT MODEL' + "</option>");
        var $yearsDropdown = $(".select_car_year");
        $yearsDropdown.empty();
        $yearsDropdown.append("<option value="+0+">" + 'SELECT YEAR' + "</option>");
        $.each(vals, function(index, value) {
          $modelsDropdown.append("<option value="+value.id+">" + value.value + "</option>");
        });

      });
      $(".select_car_make").val(makeVal);
    }else{
      var $modelsDropdown = $(".select_car_model");
        $modelsDropdown.empty();
        $modelsDropdown.append("<option value="+0+">" + 'SELECT MODEL' + "</option>");
      
        var $yearsDropdown = $(".select_car_year");
        $yearsDropdown.empty();
        $yearsDropdown.append("<option value="+0+">" + 'SELECT YEAR' + "</option>");
    }
  });
  
  
 
  
  // Getting years list
  
  $(".select_car_model").change(function() {
    
    
      var $dropdown = $(this);
    
      var modelVal = $dropdown.val();
    if(modelVal != '0'){

      var vehicle_type = $('.tab-buttons .on').data('val');
        if(vehicle_type == 'UTV'){
          var modelListUrl = appUrlTwo+'/json/years/list';
        }else{
          var modelListUrl = appUrl+'/json/years/list';
        }
      
       modelListUrl = modelListUrl+'/'+modelVal+'?shop='+storeUrl;
      
       
      $.getJSON(modelListUrl, function(data) {

          
          var vals = data.results;
    var $yearsDropdown = $(".select_car_year");
        $yearsDropdown.empty();
        $yearsDropdown.append("<option value="+0+">" + 'Select Year' + "</option>");
    $.each(vals, function(index, value) {
      $yearsDropdown.append("<option value="+value.id+">" + value.value + "</option>");
    });

      });
      $(".select_car_model").val(modelVal);
    }else{
      var $yearsDropdown = $(".select_car_year");
        $yearsDropdown.empty();
        $yearsDropdown.append("<option value="+0+">" + 'Select Year' + "</option>");
    }
  });

  $(".select_car_year").change(function() {
    
      var $dropdown = $(this);
    
      var makeVal = $dropdown.val();
    $(".select_car_year").val(makeVal);
  });
  
  $(document).on("click", '.toggle-selector', function(event) { 
    var x = document.getElementById("selectorToggle");
    if (x.style.display === "none") {
      x.style.display = "block";
    }
     else if (!x.contains(event.target)) {
       x.style.display = "none";
    } 
     else {
      x.style.display = "none";
    }

    document.querySelectorAll(".tab-buttons .on").forEach((tabview) => {
      tabview.classList.remove("on");
    });

     document.querySelectorAll(".tab-buttons .tab").forEach((tabview) => {
      if(tabview.dataset.val == 'CAR-TRUCKS-VANS'){
        tabview.classList.add("on");
      }
      
    });
    //loadMakeDropdown();

    
    
    event.stopPropagation();
  });

  
  $(document).on("click", function(event) {
  var x = document.getElementById("selectorToggle");

  if (x.style.display === "block" && !x.contains(event.target)) {
    // If the toggle element is visible and the click occurred outside of it, hide it
    x.style.display = "none";
  }
});

  
 $(document).on("click", '.mobile-toggle-selector', function(event) {
      var mobileModalWrapper = document.querySelector('.mobile-modal-wrapper');
       console.log(mobileModalWrapper,'mobileModalWrapper');
       mobileModalWrapper.classList.add("mobile-search-toggle");
     event.stopPropagation();
 });
  
 $(document).on("click", '.close_mobile-search-vehicle', function(event) {
      var mobileModalWrapper = document.querySelector('.mobile-modal-wrapper');
       console.log(mobileModalWrapper,'mobileModalWrapper');
       mobileModalWrapper.classList.remove("mobile-search-toggle");
     event.stopPropagation();
 });

  

  
  $(document).on("click", '#selector_search_', function(event) { 
    
      var $dropdown = $(".select_car_year");
      
      var $makesDropdown = $(".select_car_make");
      var makeVal = $makesDropdown.val();
      
      var $modelsDropdown = $(".select_car_model");
      var modelVal = $modelsDropdown.val();
    
      $('#questions-content .continue').removeClass('btn');
      
      var yearVal = $dropdown.val();
      if(makeVal != '0' && modelVal != '0' && yearVal != '0'){
        $('.selector_reset').show();
       getPopup(makeVal,modelVal,yearVal);

      }else{
        $('#selector_search_').notify('Please select options to continue',{ position:"top center", className: "error" } );
      }
  });

  $(document).on("click", '#selector_search_2', function(event) { 
    
      var $dropdown = $(".select_car_year");
      
      var $makesDropdown = $(".select_car_make");
      var makeVal = $makesDropdown.val();
      
      var $modelsDropdown = $(".select_car_model");
      var modelVal = $modelsDropdown.val();
    
      $('#questions-content .continue').removeClass('btn');
      
      var yearVal = $dropdown.val();
      if(makeVal != '0' && modelVal != '0' && yearVal != '0'){
        $('.selector_reset').show();
       getPopup(makeVal,modelVal,yearVal);

      }else{
        $('#selector_search_2').notify('Please select options to continue',{ position:"top center", className: "error" } );
      }
  });

  $(document).on("click", '.selector_reset', function(event) { 
    
      location.href = '/';
  });
  
  $(document).on("click", '.use_vehicle_selector', function(event) { 
    var $btn = $(this);
    window.scrollTo(0, 0);
    
    $('.use_vehicle_selector_text').show();
    setTimeout(function () {
        $('.use_vehicle_selector_text').hide();
    }, 5000);
  });
  
  $(document).on("click", '.continue', function(event) { 
    var $btn = $(this);
    if($btn.hasClass('btn')){
      var totalScreens = $(this).data('screens');
      var current = $(this).data('current');
      var type = $(this).data('type');
      var lastQuestion = $(this).data('question');
      
      var $makesDropdown = $(".select_car_make");
      var makeVal = $makesDropdown.val();
      
      var $modelsDropdown = $(".select_car_model");
      var modelVal = $modelsDropdown.val();
      
      var $yearsDropdown = $(".select_car_year");
      var yearVal = $yearsDropdown.val();
      
      if(makeVal != '0' && modelVal != '0' && yearVal != '0'){
    
      
      }else{
     var makeVal = $.urlParam('make');
       var modelVal = $.urlParam('model');
       var yearVal = $.urlParam('year');
  
      } 
      var nextScreen = current +1;
      
      var data_form = {
          make    : makeVal,
          model   : modelVal,
          year    : yearVal,
          screen  : nextScreen
        };
      var categories = {
          make    : makeVal,
          model   : modelVal,
          year    : yearVal
        };
        //console.log(data_form);
          var vehicle_type = getCookie("vehicle_type");
          if(vehicle_type == 'UTV'){
             var url = appUrlTwo+'/json/search/product?shop='+storeUrl;
          }else{
             var url = appUrl+'/json/search/product?shop='+storeUrl;
          }
      
      
        
        
      
      //console.log('totalScreens='+totalScreens);
      //console.log('current='+current);
      //console.log('type='+type);
      
      
      
      if(type == 1){
        if(totalScreens == current){
          var handle = $(".select_car_image:checked").data('handle');
            var answer = $(".select_car_image:checked").data('title');
            if(typeof handle === 'undefined'){
              $('.continue').notify('Please select option to continue',{ position:"top center", className: "error" } );
            }else{
              var queryString = $.param(data_form);
              window.location.href = '/products/'+handle+'?'+queryString;
            }
        }else{
      var checkSelection = $('.select_car_image:checked').data('handle');
            var answer = $(".select_car_image:checked").data('title');
            if(typeof checkSelection === 'undefined'){
                $('.continue').notify('Please select option to continue',{ position:"top center", className: "error" } );
           
            }else{
              //data_form['handle'] = checkSelection;
              $(this).data('handle',checkSelection);
              data_form['question'] = lastQuestion;
              data_form['answer'] = answer;
              saveUserSelection(data_form,current);
              //getScreenQuestions(url,data_form);
              getScreenQuestionsNew(url,false);
            }
        }
      }else{
        if(totalScreens == current){
          var handle = $(".select_car_text:checked").data('handle');
          var answer = $(".select_car_text:checked").data('title');
            if(typeof handle === 'undefined'){
              $('.continue').notify('Please select option to continue',{ position:"top center", className: "error" } );
            }else{
              var queryString = $.param(data_form);
              window.location.href = '/products/'+handle+'?'+queryString;
            }
       }else{
           var checkSelection = $('.select_car_text:checked').data('handle');
           var answer = $(".select_car_text:checked").data('title');
            if(typeof checkSelection === 'undefined'){
                $('.continue').notify('Please select option to continue',{ position:"top center", className: "error" } );
           
            }else{
              //data_form['handle'] = checkSelection;
              $(this).data('handle',checkSelection);
              data_form['question'] = lastQuestion;
              data_form['answer'] = answer;
              saveUserSelection(data_form,current);
              //getScreenQuestions(url,data_form);
              getScreenQuestionsNew(url,false);
            }
        }
      }
      
      
      
    }else{
    $('.continue').notify('Please select option to continue',{ position:"top center", className: "error" } );
    }
  });
  
  $(document).on("click", '.back', function(event) { 
    var $btn = $(this);
    var totalScreens = $btn.data('screens');
    var current = $btn.data('current');
    var type = $btn.data('type');

    var $makesDropdown = $(".select_car_make");
    var makeVal = $makesDropdown.val();

    var $modelsDropdown = $(".select_car_model");
    var modelVal = $modelsDropdown.val();

    var $yearsDropdown = $(".select_car_year");
    var yearVal = $yearsDropdown.val();

    if(makeVal != '0' && modelVal != '0' && yearVal != '0'){


    }else{
      var makeVal = $.urlParam('make');
      var modelVal = $.urlParam('model');
      var yearVal = $.urlParam('year');

    } 
    var prevScreen = current - 1;

    var data_form = {
      make    : makeVal,
      model   : modelVal,
      year  : yearVal,
      screen  : prevScreen
    };
    //console.log(data_form);

    var vehicle_type = getCookie("vehicle_type");
          if(vehicle_type == 'UTV'){
             var url = appUrlTwo+'/json/search/product?shop='+storeUrl;
          }else{
             var url = appUrl+'/json/search/product?shop='+storeUrl;
          }
    
      
   
    

    getScreenQuestionsNew(url,true);
      
      
      
    
  });

  $(document).on("click", '.select_car_image_img', function(event) { 
    event.preventDefault();
    var $checkboxVal = $(this).data('handle');
    $('.select_car_image_'+$checkboxVal).prop("checked", true);
    $('.select_car_image_'+$checkboxVal).trigger('click');
  });

  $(document).on("click", '.select_car_image', function(event) { 
    var $checkboxVal = $(this).val();
    console.log($checkboxVal);
    if($checkboxVal){
      $('#questions-content .continue').addClass('btn');
      /*setTimeout(function () {
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        }else{
            $('#questions-content .continue').trigger('click');
        }
    }, 500);*/
        
      
      }else{
        $('#questions-content .continue').removeClass('btn');
      }
  });

   $(document).on("click", '.select_car_text_cap', function(event) { 
    event.preventDefault();
    var $checkboxVal = $(this).data('handle');
     $('.select_car_text_'+$checkboxVal).prop("checked", true);
    $('.select_car_text_'+$checkboxVal).trigger('click');
  });
  
  $(document).on("click", '.select_car_text', function(event) { 
    var $checkboxVal = $(this).val();
    console.log($checkboxVal);
   $('#questions-content .text-only span').removeClass('active');
    if($checkboxVal){
      $(this).next().addClass('active');
        $('#questions-content .continue').addClass('btn');
        /*setTimeout(function () {
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        }else{
            $('#questions-content .continue').trigger('click');
        }
    }, 500);*/
      }else{
        $('#questions-content .continue').removeClass('btn');
        $('#questions-content .text-only span').removeClass('active');
      }
  });
  
  $(document).on("click", '#edit_vehicle_selection', function(event) { 
    var makeVal = $.urlParam('make');
    var modelVal = $.urlParam('model');
    var yearVal = $.urlParam('year');
  
    if(makeVal && modelVal && yearVal){
      getPopup(makeVal,modelVal,yearVal);
    }
    
  });


  
  // Get the modal
  var modal = document.getElementById("questions-content");

  // Get the button that opens the modal
  var btn = document.getElementById("questions-btn");

  // Get the <span> element that closes the modal
  var span = modal.getElementsByClassName("close")[0];

  // When the user clicks on the button, open the modal
  btn.onclick = function() {
    modal.style.display = "block";
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function(event) {
    if(event.target == span){
      console.log("testing: did close");
      modal.style.display = "none";
    var $yearsDropdown = $(".select_car_year");
    $yearsDropdown.val(0);
    resetUserSelection();
    } else {
      console.log("testing: did not close");
      console.log(event.target)
    }
    
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      var $yearsDropdown = $(".select_car_year");
      $yearsDropdown.val(0);
      resetUserSelection();
    }
  }

  
  
  $.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                      .exec(window.location.search);

    return (results !== null) ? results[1] || 0 : false;
  }
  
  var makeVal = $.urlParam('make');
  var modelVal = $.urlParam('model');
  var yearVal = $.urlParam('year');
  var editPopup = $.urlParam('editpopup');

  
  
  var checkProductPage = $('body').hasClass('template-product');
  if(checkProductPage){
    var productHANDLE = $('#genie_product_detail').data('handle');
     var makeVal = $.urlParam('make');
      var modelVal = $.urlParam('model');
      var yearVal = $.urlParam('year');
  var editPopup = $.urlParam('editpopup');
    var screen = $.urlParam('screen');
    var answer = $.urlParam('answer');
    
      if(makeVal && modelVal && yearVal){
        $('.ymmsearhcustom').addClass('fadein');
                $('.product_main').addClass('fadein');
        $.LoadingOverlay("show");

        console.log($('.select_car_make'));
        setTimeout(function(){
            $('.select_car_make').val(makeVal);
            $('.select_car_make').trigger('change');
               setTimeout(function(){
                $('.select_car_model').val(modelVal); 
                $('.select_car_model').trigger('change');
                
                setTimeout(function(){
                  
                $('.select_car_year').val(yearVal);
                  $('.selector_reset').show();
              // var prodTitle = $(".select_car_year option:selected").text()+' '+$(".select_car_make option:selected").text()+ ' '+$(".select_car_model option:selected").text();
             // $('.productView-title span').text(prodTitle.toUpperCase());
                  
              }, 500);
              
            }, 500);
          }, 500);
        
       //if(editPopup){
           //$('.single-product-page').show();
        //}else{
        
        
        if(answer){
          var data_form = {
          make    : makeVal,
          model   : modelVal,
          year  : yearVal,
          handle : productHANDLE,
          screen : screen,
          answer:answer
        };
        }else{
          var data_form = {
          make    : makeVal,
          model   : modelVal,
          year  : yearVal,
          handle : productHANDLE,
          screen : screen
        };
        }
        
        //console.log(data_form);

        var vehicle_type = getCookie("vehicle_type");
          if(vehicle_type == 'UTV'){
             var url = appUrlTwo+'/json/product/detail?shop='+storeUrl;
          }else{
           var url = appUrl+'/json/product/detail?shop='+storeUrl;
          }
        
        
        
        $.ajax({
          type: 'POST',
          url: url,
          data: data_form,
          async: false,
          cache: false,
          xhrFields: {
             withCredentials: false
          },
          success: function(data) {
            //console.log(data);
            if(data.status){
              //console.log(data.title);
        $('.productView-title span').html(data.title);
              
                var fullHtml = '';
              $.each(data.results, function() {
                
                var questionDetail = this;
                //console.log(questionDetail);
                if(questionDetail.answer){
                  var answersHtml = '<tr> <td class="tb-title">';
                  var answersHtml = answersHtml + questionDetail.question+ ' </td><td> '+questionDetail.answer + '</td>';
                  var answersHtml = answersHtml + '</tr>';
                  fullHtml = fullHtml + answersHtml;
                }

                


              });

              //console.log(fullHtml);
              
              if(fullHtml != ''){
                $('#tab-custom-tab-mobile .tab-popup-content').html('<table><tbody>'+fullHtml+'</tbody>');
                $('#edit_vehicle_selection .product-title').text(data.title);
                $('#edit_vehicle_selection').show();

                setTimeout(function(){
                       $('.ymmsearhcustom').removeClass('fadein');
                      $('.product_main').removeClass('fadein');
                  
              }, 1000);
                
               

                
                
              }else{
                $('.ymmsearhcustom').removeClass('fadein');
                $('.product_main').removeClass('fadein');
                $('.edit_vehicle_selection_parent').hide();
              }
              $('.single-product-page').show();
              $.LoadingOverlay("hide");
              
      



            }else{
              $.LoadingOverlay("hide");
               $('.single-product-page').show();
            }

          },
          error: function( jqXhr, textStatus, errorThrown ){
          $.LoadingOverlay("hide");
               $('.single-product-page').show();


        },
        statusCode: {
          500: function() {
          $.LoadingOverlay("hide");
               $('.single-product-page').show();
          }
        }
        });
    //}
        
      }else{
        var enableProductsSkus = $('#enable-products').data('enable');
        console.log(enableProductsSkus);
        if(enableProductsSkus == 1){
           
        }else{
           $('#product-add-to-cart').hide();
          $('.productView-stickyCart').hide();
            $('.productView-payment').hide();
          $('.productView-options').hide();
          $('.productView-group').hide();
           $('.productView-tab').hide();

          
          
$('.productView-form').append(generateVehicleSelectorWarning());
        }
        
        $('.edit_vehicle_selection_parent').hide();
        $.LoadingOverlay("hide");
      }
   
    
    if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      $('.select_your_vehicle_content').hide();
      $('.genie_dropdowns').removeClass('new_color');
      
      $('.select_your_vehicle').text('Edit Your Vehicle');
      
      
      $(document).on("click", '.select_your_vehicle', function(event) { 
        $('.select_car_make').val(makeVal);
        $('.select_car_make').trigger('change');
        setTimeout(function(){
          $('.select_car_model').val(modelVal); 
          $('.select_car_model').trigger('change');
          
          setTimeout(function(){
          $('.select_car_year').val(yearVal);
        }, 1000);
          
        }, 1000);
        
        //$('.select_car_model').trigger('change');
        //$('.select_car_year').val(yearVal);
        
        
        $('.select_your_vehicle_content').show();
        $('.genie_dropdowns').addClass('new_color');
        $('.select_your_vehicle_close_btn').show();
        

      });
      
      $(document).on("click", '.select_your_vehicle_close_btn', function(event) { 
        $('.select_your_vehicle_content').hide();
        $('.select_your_vehicle_close_btn').hide();
      $('.genie_dropdowns').removeClass('new_color');

      });
    }
    
  }
  
});

function TabView(tabClass, tabviewClass) {
    document.querySelectorAll("." + tabClass).forEach((dom) => {
      dom.addEventListener("click", (e) => {
        // Tab
        
        document.querySelectorAll("." + tabClass + ".on").forEach((tabview) => {
          tabview.classList.remove("on");
        });
        if(e.currentTarget.dataset.val == 'CAR-TRUCKS-VANS'){
           e.currentTarget.className = tabClass + " vehicle_type_select button_b " + " on";
        }else{
           e.currentTarget.className = tabClass + " vehicle_type_select  " + " on";
        }
       
        

        loadMakeDropdown();

        if(e.currentTarget.dataset.val == 'CAR-TRUCKS-VANS'){
          document.querySelector(".toggle-selector").classList.remove("nav-cta-2");
          document.querySelector(".toggle-selector").classList.add("nav-cta");
        }else{
          document.querySelector(".toggle-selector").classList.remove("nav-cta");
          document.querySelector(".toggle-selector").classList.add("nav-cta-2");
        }


         

          document.querySelector("#selectorToggle").classList.remove("UTV");
          document.querySelector("#selectorToggle").classList.remove("CAR-TRUCKS-VANS");
      
          document.querySelector("#selectorToggle").classList.add(e.currentTarget.dataset.val);
      
        // Tabview
        /*const tabviewId = e.currentTarget.dataset.target;
        document.querySelectorAll("." + tabviewClass).forEach((tabview) => {
          tabview.style.display = "none";
        });
        document.querySelector(tabviewId).style.display = "block";*/
      });
    });
  }



function getScreenQuestionsNew(url,back){
  
  $.ajax({
      type: 'POST',
      url: url,
      data: getUserSelection(back),
      async: false,
    xhrFields: {
             withCredentials: false
          },
      cache: false,
      success: function(data) {
        if(data.status){
          $("#questions-content .continue").data('screens',data.totalScreens);
          $("#questions-content .continue").data('current',data.screen);
          $("#questions-content .continue").removeClass('btn');
          //console.log('screens ='+data.totalScreens);
          //console.log('current ='+data.screen);
          
          var currentScreen = data.screen;
          var totalScreen = data.totalScreens;
          if(currentScreen > 1 && currentScreen <=totalScreen ){
            $("#questions-content .back").data('screens',data.totalScreens);
            $("#questions-content .back").data('current',data.screen);
            $("#questions-content .back").show();
          }else if(currentScreen == 1){
            $("#questions-content .back").hide();
          }
          
          var question = data.uniqueQuestion[0] ;
          $('#questions-content h2').text(question);
          $("#questions-content .continue").data('question',question);
          $("#questions-content .back").data('question',question);
          
          var qClass = getClassOfDiv(data);
          
          if(data.screenQuestions.length == 0){
            var handle = $("#questions-content .continue").data('handle');
             if(typeof handle === 'undefined'){
                $('.continue').notify('Contact Support',{ position:"top center", className: "error" } );
             }else{
              var data_form = getQueryStringArray();
               console.log(data_form);
              var queryString = $.param(data_form);
               console.log(queryString);
              window.location.href = '/products/'+handle+'?'+queryString;
             }
          }else{
            if(data.is_image){
            $('#questions-content .image-only').html('');
            $("#questions-content .continue").data('type',1);
            $("#questions-content .back").data('type',1);

            $('#questions-content .text-only').hide();


            var fullHtml = '';
            $.each(data.screenQuestions, function() {
              var questionDetail = this;
              var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              var imageHtml = '<label class="grid__item  '+qClass+'">';
              var imageHtml = imageHtml + '<input class="select_car_image select_car_image_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_image" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
              var imageHtml = imageHtml + '<img class="img-responsive select_car_image_img" data-handle="'+answerId+'" src="'+questionDetail.url+'">';
              var answer = questionDetail.answer;
                      answer = answer.toLowerCase();
                      if(answer == 'yes' || answer == 'no'){
                      }else{ 
                      var imageHtml = imageHtml + '<span class="caption">'+questionDetail.answer+'</span>';
                      }
              var imageHtml = imageHtml + '</label>';

              fullHtml = fullHtml + imageHtml;


            });
              
            $('#questions-content .image-only').html(fullHtml);
              if(data.answers == 1){
                $('.select_car_image').trigger('click');
              }
            $('#questions-content .image-only').show();

          }else{
            $("#questions-content .continue").data('type',0);
            $("#questions-content .back").data('type',0);
            
            $('#questions-content .image-only').hide();
            //console.log('hello ss');
             var fullHtml = '';
            $.each(data.screenQuestions, function() {
              var questionDetail = this;
              var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              
              
              
              var imageHtml = '<label class="grid__item '+qClass+' ">';
              var imageHtml = imageHtml + '<input class="select_car_text select_car_text_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_text" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
              var imageHtml = imageHtml + '<span data-handle="'+answerId+'" class="caption select_car_text_cap">'+questionDetail.answer+'</span>';
              var imageHtml = imageHtml + '</label>';

              fullHtml = fullHtml + imageHtml;


            });
            $('#questions-content .text-only').html(fullHtml);
            if(data.answers == 1){
                $('.select_car_text').trigger('click');
              }
            
            $('#questions-content .text-only').show();
          }

          }

        }else{
      $('.continue ').notify(data.message,{ position:"top center", className: "error" } );
        }
        //console.log(data);
      }
    });
}

function getScreenQuestions(url,data_form){
  $.ajax({
      type: 'POST',
      url: url,
      data: data_form,
      async: false,
      cache: false,
    xhrFields: {
             withCredentials: false
          },
      success: function(data) {
        if(data.status){
          $("#questions-content .continue").data('screens',data.totalScreens);
          $("#questions-content .continue").data('current',data.screen);
          
          //console.log('screens ='+data.totalScreens);
          //console.log('current ='+data.screen);
          
          var currentScreen = data.screen;
          var totalScreen = data.totalScreens;
          if(currentScreen > 1 && currentScreen <=totalScreen ){
            $("#questions-content .back").data('screens',data.totalScreens);
            $("#questions-content .back").data('current',data.screen);
            $("#questions-content .back").show();
          }else if(currentScreen == 1){
            $("#questions-content .back").hide();
          }
          
          var question = data.uniqueQuestion[0] ;
          $('#questions-content h2').text(question);
          $("#questions-content .continue").data('question',question);
          $("#questions-content .back").data('question',question);
          
          var qClass = getClassOfDiv(data);
          
          if(data.screenQuestions.length == 0){
            var handle = $("#questions-content .continue").data('handle');
             if(typeof handle === 'undefined'){
                $('.continue').notify('Contact Support',{ position:"top center", className: "error" } );
             }else{
              var queryString = $.param(data_form);
                window.location.href = '/products/'+handle+'?'+queryString;
             }
          }else{
            if(data.is_image){
            $('#questions-content .image-only').html('');
            $("#questions-content .continue").data('type',1);
            $("#questions-content .back").data('type',1);

            $('#questions-content .text-only').hide();


            var fullHtml = '';
            $.each(data.screenQuestions, function() {
              var questionDetail = this;
              var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              var imageHtml = '<label class="grid__item  '+qClass+'">';
              var imageHtml = imageHtml + '<input class="select_car_image select_car_image_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_image" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
              var imageHtml = imageHtml + '<img class="img-responsive select_car_image_img" data-handle="'+answerId+'"  src="'+questionDetail.url+'">';
              var answer = questionDetail.answer;
                      answer = answer.toLowerCase();
                      if(answer == 'yes' || answer == 'no'){
                      }else{ 
                      var imageHtml = imageHtml + '<span class="caption">'+questionDetail.answer+'</span>';
                      }
              var imageHtml = imageHtml + '</label>';

              fullHtml = fullHtml + imageHtml;


            });
              
            $('#questions-content .image-only').html(fullHtml);
              if(data.answers == 1){
                $('.select_car_image').trigger('click');
              }
            $('#questions-content .image-only').show();

          }else{
            $("#questions-content .continue").data('type',0);
            $("#questions-content .back").data('type',0);
            
            $('#questions-content .image-only').hide();
            //console.log('hello ss');
             var fullHtml = '';
            $.each(data.screenQuestions, function() {
              var questionDetail = this;
              var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              
              
              
              var imageHtml = '<label class="grid__item '+qClass+' ">';
              var imageHtml = imageHtml + '<input class="select_car_text select_car_text_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_text" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
              var imageHtml = imageHtml + '<span data-handle="'+answerId+'" class="caption select_car_text_cap">'+questionDetail.answer+'</span>';
              var imageHtml = imageHtml + '</label>';

              fullHtml = fullHtml + imageHtml;


            });
            $('#questions-content .text-only').html(fullHtml);
            if(data.answers == 1){
                $('.select_car_text').trigger('click');
              }
            
            $('#questions-content .text-only').show();
          }

          }

        }else{
      $('.continue ').notify(data.message,{ position:"top center", className: "error" } );
        }
        //console.log(data);
      }
    });
}

function getPopup(makeVal,modelVal,yearVal){
  var data_form = {
          make    : makeVal,
          model   : modelVal,
          year  : yearVal
        };
        //console.log(data_form);

          var vehicle_type = getCookie("vehicle_type");
          if(vehicle_type == 'UTV'){
              var url = appUrlTwo+'/json/search/product?shop='+storeUrl;
          }else{
              var url = appUrl+'/json/search/product?shop='+storeUrl;
          }
        
        
        
        $.ajax({
          type: 'POST',
          url: url,
          data: data_form,
          async: false,
          cache: false,
          xhrFields: {
             withCredentials: false
          },
          success: function(data) {
            if(data.status){
              $("#questions-content .continue").data('screens',data.totalScreens);
              $("#questions-content .continue").data('current',data.screen);
              
              if(data.is_image){
                 $("#questions-content .continue").data('type',1);
              }else{
                 $("#questions-content .continue").data('type',0);
              }
              
              var qClass = getClassOfDiv(data);
              
              
              
              if(data.totalScreens == 0){
                
                var productHandle = data.results[0].handle;
                 if(typeof productHandle === 'undefined'){
                    $('.continue').notify('Contact Support',{ position:"top center", className: "error" } );
                 }else{
                  var queryString = $.param(data_form);
                    window.location.href = '/products/'+productHandle+'?'+queryString+'&editpopup=1';
                 }
                
                
              }else{
                var question = data.uniqueQuestion[0] ;
                $('#questions-content h2').text(question);
                $("#questions-content .continue").data('question',question);
                $("#questions-content .back").data('question',question);
                
                if(data.totalScreens == 1){
                  
                  if(data.is_image){
                  $('#questions-content .text-only').hide();
                    
                    var fullHtml = '';
                  $.each(data.screenQuestions, function() {
                      var questionDetail = this;
                    var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                      var imageHtml = '<label class="grid__item '+qClass+'">';
                      var imageHtml = imageHtml + '<input class="select_car_image select_car_image_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_image" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
                      var imageHtml = imageHtml + '<img class="img-responsive select_car_image_img" data-handle="'+answerId+'" src="'+questionDetail.url+'">';
                      var answer = questionDetail.answer;
                      answer = answer.toLowerCase();
                      if(answer == 'yes' || answer == 'no'){
                      }else{ 
                      var imageHtml = imageHtml + '<span class="caption">'+questionDetail.answer+'</span>';
                      }
                        var imageHtml = imageHtml + '</label>';
                      
                      fullHtml = fullHtml + imageHtml;
                      
                      
                    });
                    $('#questions-content .image-only').html(fullHtml);
                     if(data.answers == 1){
                $('.select_car_image').trigger('click');
              }
                    $('#questions-content .image-only').show();
                    
                  }else{
                    
                    $('#questions-content .image-only').hide();
                      
                     var fullHtml = '';
                    
                    //console.log(qClass);
                      $.each(data.screenQuestions, function() {
                        var questionDetail = this;
                        var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                        var imageHtml = '<label class="grid__item '+qClass+' ">';
                        var imageHtml = imageHtml + '<input class="select_car_text select_car_text_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_text" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
                        var imageHtml = imageHtml + '<span data-handle="'+answerId+'" class="caption select_car_text_cap">'+questionDetail.answer+'</span>';
                        var imageHtml = imageHtml + '</label>';

                        fullHtml = fullHtml + imageHtml;


                      });
                      $('#questions-content .text-only').html(fullHtml);
                     if(data.answers == 1){
                $('.select_car_text').trigger('click');
              }
                    $('#questions-content .text-only').show();

                  }
                  
                }else{
                  
                  if(data.is_image){
                    $('#questions-content .text-only').hide();
                    
                    var fullHtml = '';
                  $.each(data.screenQuestions, function() {
                      var questionDetail = this;
                    var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                      var imageHtml = '<label class="grid__item '+qClass+'">';
                      var imageHtml = imageHtml + '<input class="select_car_image select_car_image_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_image" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
                      var imageHtml = imageHtml + '<img class="img-responsive select_car_image_img" data-handle="'+answerId+'" src="'+questionDetail.url+'">';
                      var answer = questionDetail.answer;
                      answer = answer.toLowerCase();
                      if(answer == 'yes' || answer == 'no'){
                      }else{ 
                      var imageHtml = imageHtml + '<span class="caption">'+questionDetail.answer+'</span>';
                      }
                      var imageHtml = imageHtml + '</label>';
                      
                      fullHtml = fullHtml + imageHtml;
                      
                      
                    });
                    $('#questions-content .image-only').html(fullHtml);
                     if(data.answers == 1){
                $('.select_car_image').trigger('click');
              }
                    $('#questions-content .image-only').show();
                  }else{
                    $('#questions-content .image-only').hide();
                     var fullHtml = '';
                     //console.log(data.screenQuestions.length);
                      $.each(data.screenQuestions, function() {
                        var questionDetail = this;
                        var answerId = questionDetail.answer.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                        var imageHtml = '<label class="grid__item '+qClass+' ">';
                        var imageHtml = imageHtml + '<input class="select_car_text select_car_text_'+answerId+'" type="radio" data-handle="'+this.handle+'" name="select_car_text" value="'+questionDetail.sku+'" data-title="'+questionDetail.answer+'">';
                        var imageHtml = imageHtml + '<span data-handle="'+answerId+'" class="caption select_car_text_cap">'+questionDetail.answer+'</span>';
                        var imageHtml = imageHtml + '</label>';

                        fullHtml = fullHtml + imageHtml;


                      });
                      $('#questions-content .text-only').html(fullHtml);
                    
                     if(data.answers == 1){
                $('.select_car_text').trigger('click');
              }
                    

                  }
                }
                
                
                
                
                
                
                
                $('#questions-btn').trigger('click');
              }
              
            }else{
              $('.select_car_year ').notify(data.message,{ position:"top center", className: "error" } );
            }
            //console.log(data);
          }
        });
}

function getClassOfDiv(data){

  var questionLength = data.screenQuestions.length;
              var qClass = '';
              var makeItWhole = checkAnswersLength(data);
              
              if(questionLength == 1){
                qClass = 'col-lg-12 col-md-12 col-sm-12';
              }else if(questionLength == 2){
                if(data.is_image){
                qClass = 'col-lg-6 col-md-6 col-sm-12 ';
                }else{
                  if(makeItWhole){
                   qClass = 'col-lg-12 col-md-12 col-sm-12 spacing';
                  }else{
                    qClass = 'col-lg-6 col-md-6 col-sm-12 spacing';
                  }
                    
                }
              }else if(questionLength == 3){
                if(data.is_image){
                  qClass = 'col-lg-4 col-md-4 col-sm-12';
                }else{
                  if(makeItWhole){
                   qClass = 'col-lg-12 col-md-12 col-sm-12 spacing';
                  }else{
                    qClass = 'col-lg-4 col-md-4 col-sm-12 spacing';
                  }
                    
                }
              }else if(questionLength == 4){
                if(data.is_image){
                  qClass = 'col-lg-3 col-md-3 col-sm-12';
                }else{
                  if(makeItWhole){
                   qClass = 'col-lg-12 col-md-12 col-sm-12 spacing';
                  }else{
                    qClass = 'col-lg-12 col-md-12 col-sm-12 spacing';
                  }
                }
              }
  
  return qClass;
}

function checkAnswersLength(data){
  var split = false;
  $.each(data.screenQuestions, function() {
      var questionDetail = this;
      var answerLength = questionDetail.answer.length;
      if(answerLength > 18){
        split =  true;
      }
      
    });
  
  return split;
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

function saveUserSelection(data_form,current){
  var savedCategories = getCookie('userselection');
  var savedCategoriesArr = $.deparam(savedCategories);  
  
  
  if(savedCategories.length == 0 ){
    data_form['question'+current] = data_form.question;
    data_form['answer'+current] = data_form.answer;
    delete(data_form['question']) ;
    delete(data_form['answer']);
    data_form['fullsearch'] = 1;
    var categoriesString = $.param(data_form, true);
    setCookie('userselection',categoriesString);
  }else{
    savedCategoriesArr['question'+current] = data_form.question;
    savedCategoriesArr['answer'+current] = data_form.answer;
    savedCategoriesArr['screen'] = data_form.screen;
    var savedCategoriesString = $.param(savedCategoriesArr, true);
    setCookie('userselection',savedCategoriesString);

  }
  
}

function getUserSelection(back){
  var savedCategories = getCookie('userselection');
  var savedCategoriesArr = $.deparam(savedCategories);
  if(back){
    savedCategoriesArr['screen'] = savedCategoriesArr['screen'] -1;
    delete(savedCategoriesArr['answer'+savedCategoriesArr['screen']]);
    delete(savedCategoriesArr['question'+savedCategoriesArr['screen']]);
  }
  return savedCategoriesArr;
}

function resetUserSelection(){
 setCookie('userselection','');
}

function getQueryStringArray(){
  
  var data_form = getUserSelection(false);
  console.log(data_form);
  
  var newDataForm = {
    make    : data_form['make'],
    model   : data_form['model'],
    year  : data_form['year']
  };
  console.log(newDataForm);
  return newDataForm;
}
  function loadMakeDropdown(){
        var vehicle_type = $('.tab-buttons .on').data('val');
        if(vehicle_type == 'UTV'){
          var makeListUrl = appUrlTwo+'/json/makes/list?shop='+storeUrl;
        }else{
          var makeListUrl = appUrl+'/json/makes/list?shop='+storeUrl;
        }
    setCookie("vehicle_type", vehicle_type, 365);
  	
    
     $.ajax({
          type: 'GET',
          url: makeListUrl,
          async: false,
          cache: false,
          xhrFields: {
             withCredentials: false
          },
          success: function(data) {
        	  var vals = data.results;
              var $makesDropdown = $(".select_car_make");
              $makesDropdown.empty();
                  $makesDropdown.append("<option value="+0+">" + 'MAKE' + "</option>");
              $.each(vals, function(index, value) {
                $makesDropdown.append("<option value="+value.id+">" + value.value + "</option>");
              });

          }
        });
    $('.select_car_make').val(0).trigger('change');
  }
  })( jQuery );